/*
A component that pulses color to indicate loading. More visually subtle than the spinner
*/

import styled from 'styled-components';
import { DarkenMedium } from '../../styles/themes';

export const LoadingPulser = () => {
  return <LoadingPulserStyle />;
};

const LoadingPulserStyle = styled.div`
  width: 100%;
  height: 100%;

  @keyframes pulse {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  border-radius: inherit;
  background-color: ${DarkenMedium};
  animation-name: pulse;
  animation-duration: 0.4s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
`;
